import {IEventEmitter, TypesCore} from "@dp-instant/interfaces";
import {Localize} from "@dp-instant/i18n";
import {Button, UIEvents, useInjection, visibilityEffect} from "@dp-instant/ui";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import {ContinueButton} from "@game/ui/components/ContinueButton/ContinueButton";
import {UIConstants} from "@game/ui/constants";
import {CoinsIndicator} from "@game/ui/components/CoinsIndicator/CoinsIndicator";
import cn from "classnames";
import {BattleResults} from "./BattleResults";
import "./BattleResultsPopup.less";

export type BattleResultsPopupProps = {
    win: boolean;
    onContinue?: (success: boolean) => void | Promise<void>;
};

export const BattleResultsPopup = ({win = false, onContinue}: BattleResultsPopupProps) => {
    const dispatcher = useInjection<IEventEmitter>(TypesCore.dispatcher);
    const model = useInjection<GameModel>(TypesGame.model);
    const [invisible] = visibilityEffect(UIConstants.popup.startDelay);

    const passedStage = model.currentContinent.stageLevel - 1;
    const continentName = model.currentContinent.data.id;

    const next = async (success = true) => {
        dispatcher.emit(UIEvents.POPUP, {id: null});
        onContinue && (await onContinue(success));
    };

    return (
        <div className="popups">
            <div className={cn("coins-bar")}>
                <CoinsIndicator
                    className={cn("coins-indicator", "coins-indicator_filled")}
                    total={model.cookie.coins}
                />
            </div>
            <div className={cn("popup-battle-results")}>
                <div className={cn("popup", {invisible})}>
                    <div className="popup__title">
                        {Localize.get("ui-battle-battle_title", "Battle Results")}
                        <div
                            className={cn("popup__title-detailed", {
                                "popup__title-detailed_lose": !win
                            })}
                        >
                            <span>{continentName} </span>
                            <span>{" stage "}</span>
                            {`#${win ? passedStage + 1 : passedStage + 2}`}
                        </div>
                    </div>
                    <div className="popup__body">
                        <BattleResults
                            passedStage={passedStage}
                            isLevelFinished={model.currentContinent.isFinished}
                        />
                    </div>
                    {win ? (
                        <ContinueButton onClick={() => next(true)} />
                    ) : (
                        <Button
                            className={cn("try-again-button", "btn-green")}
                            onClick={() => next(false)}
                        >
                            {Localize.get("ui-try-again-button", "TRY AGAIN")}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};
